/**
 * Conditional logging utility
 * Only logs in development mode to improve production performance
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Logs only in development mode
   */
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Always logs errors (important for production debugging)
   */
  error: (...args: any[]) => {
    console.error(...args);
  },

  /**
   * Logs warnings only in development mode
   */
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },

  /**
   * Logs info only in development mode
   */
  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Logs debug messages only in development mode
   */
  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },

  /**
   * Group logs (only in development)
   */
  group: (...args: any[]) => {
    if (isDev) {
      console.group(...args);
    }
  },

  /**
   * End group (only in development)
   */
  groupEnd: () => {
    if (isDev) {
      console.groupEnd();
    }
  },
};
